import { Container, Typography, Box, Card, CardContent, Avatar, Rating } from '@mui/material';
import { Quote } from 'lucide-react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const testimonials = [
  {
    name: 'Gerry Litrento',
    position: 'Founder, GL Collective',
    avatar: '/assets/GerryLitrento.jpg?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=256&q=80',
    quote: 'Having worked with Recruitment Intelligence for years at BankUnited, I’ve seen firsthand how their team delivers top-tier banking talent while keeping costs down. Their new AI assistant, RiC, takes that expertise even further — instantly surfacing and scoring hundreds of high-quality candidates, automating outreach, and making recruiting faster and smarter than ever. If you\'re serious about hiring better talent for less, a 30-minute demo is a no-brainer.',
    rating: 5
  },
  {
    name: 'Cassandra Krasne',
    position: 'President, Discover HR',
    avatar: '/assets/cassandrakrasne.jpeg?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=256&q=80',
    quote: 'Working with Recruitment Intelligence … never fails to impress. Their cutting-edge technology is matched by a team that’s attentive, professional, and genuinely invested in the success of both clients and candidates. They’ve consistently delivered exceptional talent who have made a meaningful impact on our organization.',
    rating: 5
  },
  {
    name: 'Kari Hamilton',
    position: 'VP of HR, Gemaire Distributors',
    avatar: '/assets/KariHamilton.jpeg?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=256&q=80',
    quote: 'We partnered with Recruitment Intelligence’s platform to help fill a Business Development Representative role in Dallas, and the results far exceeded our expectations. Within two weeks, we had 16 qualified, pre-screened candidates ready to interview—ultimately leading to multiple hires from a single search. What impressed us most was the quality of the candidates, the cost-effectiveness of the process, and the transparency of the data. Unlike traditional recruiting models, we now own the candidate data and can continue to leverage it for future hires without additional fees. The value and ROI have been outstanding, and we look forward to working with Recruitment Intelligence again. ',
    rating: 5
  },
  {
    name: 'DiShawn Dunmore',
    position: 'VP, Human Capital, Carey International',
    avatar: '/assets/DishawnDunmore.jpeg?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=256&q=80',
    quote: 'For the past seven Super Bowls, ARC Group and their Recruitment Intelligence platform has been our go-to partner in managing one of our most demanding staffing initiatives—hiring and onboarding 200–300 professional drivers in a matter of weeks... They understand urgency, deliver top-tier candidates, and do so with a level of professionalism that’s hard to find in this space. ARC with Recruitment Intelligence has consistently delivered—and we consider them an essential extension of our team during critical moments.',
    rating: 5
  }
];

const Testimonials = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 6000,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  return (
    <Box sx={{ py: 10, backgroundColor: '#f5f7fa' }}>
      <Container maxWidth="lg">
        <Box sx={{ textAlign: 'center', mb: 8 }}>
        <Typography 
            variant="overline" 
            component="div"
            sx={{ 
              color: 'primary.main',
              fontWeight: 600,
              fontSize: { xs: '2rem', md: '2.5rem' },
              letterSpacing: 1.5,
              mb: 1
            }}
          >
            SUCCESS STORIES
          </Typography>
          <Typography 
            variant="h2" 
            component="h2"
            sx={{ 
              fontWeight: 700,
              mb: 2,
              fontSize: { xs: '2rem', md: '2.5rem' }
            }}
          >
            What Our Clients Say
          </Typography>
          <Typography 
            variant="subtitle1"
            sx={{ 
              color: 'text.secondary',
              maxWidth: '700px',
              mx: 'auto',
              mb: 4
            }}
          >
            Discover how Recruitment Intelligence has helped companies of all sizes transform their hiring process.
          </Typography>
        </Box>

        <Box sx={{ mb: 8 }}>
          <Slider {...settings}>
            {testimonials.map((testimonial, index) => (
              <Box key={index} sx={{ p: 2 }}>
                <Card 
                  sx={{ 
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    borderRadius: 4,
                    boxShadow: '0 10px 30px rgba(0,0,0,0.08)',
                    position: 'relative',
                    overflow: 'visible',
                    p: 3
                  }}
                >
                  <Box 
                    sx={{ 
                      position: 'absolute',
                      top: -20,
                      left: 30,
                      width: 40,
                      height: 40,
                      borderRadius: '50%',
                      backgroundColor: 'primary.main',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: 'white',
                      boxShadow: '0 4px 10px rgba(0,0,0,0.1)'
                    }}
                  >
                    <Quote size={20} />
                  </Box>
                  
                  <CardContent sx={{ p: 0, flexGrow: 1 }}>
                    <Typography 
                      variant="body1" 
                      paragraph 
                      sx={{ 
                        mb: 4,
                        fontStyle: 'italic',
                        color: 'text.secondary',
                        fontSize: '1.05rem',
                        lineHeight: 1.6
                      }}
                    >
                      "{testimonial.quote}"
                    </Typography>
                    
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <Avatar 
                        src={testimonial.avatar} 
                        alt={testimonial.name}
                        sx={{ width: 56, height: 56, mr: 2 }}
                      />
                      <Box>
                        <Typography variant="h6" sx={{ fontWeight: 600 }}>
                          {testimonial.name}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          {testimonial.position}
                        </Typography>
                        <Rating 
                          value={testimonial.rating} 
                          readOnly 
                          size="small"
                          sx={{ mt: 0.5 }}
                        />
                      </Box>
                    </Box>
                  </CardContent>
                </Card>
              </Box>
            ))}
          </Slider>
        </Box>

        <Box 
          sx={{ 
            textAlign: 'center',
            maxWidth: '900px',
            mx: 'auto',
            p: 4,
            borderRadius: 4,
            backgroundColor: 'rgba(63, 81, 181, 0.05)',
            border: '1px dashed rgba(63, 81, 181, 0.3)'
          }}
        >
          <Typography 
            variant="h5" 
            component="p"
            sx={{ 
              fontWeight: 500,
              mb: 2,
              color: 'primary.main'
            }}
          >
            Join the companies already using RECRUITMENT INTELLIGENCE<span style={{ fontSize: '1.0em', verticalAlign: 'super' }}>®</span><br /> to streamline their hiring process.
          </Typography>
          <Typography variant="body1" color="text.secondary">
            From startups to Fortune 500 companies, our AI-powered platform is helping organizations<br/> find the best talent faster and for far less money.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Testimonials;
